import type { CSSProperties, ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

/**
 * Karte mit Überschrift, Beschreibung und Trennlinie — die gemeinsame Form im
 * Admin: Abschnitte und Tabs im Kunden-Sheet, das Berater-Sheet, der Team-
 * Bereich der Einstellungen. Vorher ging jeder dieser Orte einen eigenen Weg.
 */
export function SectionCard({ id, title, description, action, style, children }: { id?: string; title: string; description?: string; action?: ReactNode; style?: CSSProperties; children: ReactNode }) {
  return (
    <section id={id} className="rounded-lg border border-border bg-card shadow-sm" style={style}>
      <header className="flex items-center justify-between gap-4 border-b border-border px-5 py-3.5">
        <div className="min-w-0">
          <h3 className="font-heading flex items-center gap-2 text-base font-bold">{title}</h3>
          {description ? <p className="mt-0.5 text-sm text-muted-foreground">{description}</p> : null}
        </div>
        {action}
      </header>
      <div className="p-5">{children}</div>
    </section>
  );
}

/** Leerzustand in einer SectionCard: kleines Icon im grauen Kreis, im Stil der Aktivitäts-Symbole. */
export function SectionEmptyState({ icon: Icon, children }: { icon: LucideIcon; children: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-3 py-8 text-center">
      <span className="flex size-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <Icon className="size-5" aria-hidden="true" />
      </span>
      <p className="text-sm text-muted-foreground">{children}</p>
    </div>
  );
}
